import script from "./index.vue?vue&type=script&setup=true&name=colorCombinList&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=colorCombinList&lang=js"

const __exports__ = script;

export default __exports__